
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ibDArEzWbTdJkVmQbGVZol_45EBXqhtWVPwOkMjDY6i0rfMMeta } from "/app/pages/ib.vue?macro=true";
import { default as appoARvJ9pTIAlSwGNu9CDvfiuUETdLPDqEIX3DFwG66D0Meta } from "/app/pages/app.vue?macro=true";
import { default as mt5HaBHJUdkL1ehw5twrXr6QH4S43gMorcjHGOml4idnV8Meta } from "/app/pages/mt5.vue?macro=true";
import { default as faqsC9SOoZ3LrPnDZl9hif9RS2443K_45lvA62w_45yUmj868X8Meta } from "/app/pages/faqs.vue?macro=true";
import { default as tagsItSc6eNa85FbSBVWfepDLu_45o4kgBbKsIq0zQp7uloT4Meta } from "/app/pages/tags.vue?macro=true";
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as errormwD7kY_45BU1_rHGEshIkO6bNB5B0luZiwF4k9TLpjX_45IMeta } from "/app/pages/error.vue?macro=true";
import { default as forexHWvWKO_45TFU_R2vgEeQdq8yRdjhf5D2xsaxn1KUbcKLUMeta } from "/app/pages/forex.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as cryptogwYfdgetK3UjeC9V6blbrDShEjTTe7EsgPyLqmVhYJIMeta } from "/app/pages/crypto.vue?macro=true";
import { default as stocks0gyeiXfCgfZ6E_45yS9vkipUpysve5xYyH8_eYwZ4j_8oMeta } from "/app/pages/stocks.vue?macro=true";
import { default as why_45usIrT4svV7pjVCUtFd_45xjPVJKJAmA_45pPUY6DW_q_45uz_5EMeta } from "/app/pages/why-us.vue?macro=true";
import { default as careersadRifqKj5KBl1A0jECsFOk1kbe37aRjkPIRXUdW_45JV8Meta } from "/app/pages/careers.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as indicesvOpnUBq3VFWweGc3SP1NEyBEEL6FwOTysrpqL8qIZ2oMeta } from "/app/pages/indices.vue?macro=true";
import { default as glossarySzMj_UksfoiyYE5rI8z2UZIyQaox3YJ7Z23Q7kLtxNEMeta } from "/app/pages/glossary.vue?macro=true";
import { default as partnerss9lBfNyvWm1ArfVYDNYaTZPixnScXy82e9acLeU4NuYMeta } from "/app/pages/partners.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as affiliatew9cfaDyM71APVz7UWW2FzvbZkE1zKH7KCzK1xC17fh0Meta } from "/app/pages/affiliate.vue?macro=true";
import { default as webtraderlZ_45IpeYoeXTcihP2Bvi7gjpkxqpfNs7u8_vAJZBNll4Meta } from "/app/pages/webtrader.vue?macro=true";
import { default as regulationZBcGe_456XAhQsrqV32GxvNqQu0JxAJNNJ0WuFfnEzUxgMeta } from "/app/pages/regulation.vue?macro=true";
import { default as cfd_45tradingdRi7p_igLBCCjU5HHc8_Ww5t4oqnAaLsz6MMNqig3XAMeta } from "/app/pages/cfd-trading.vue?macro=true";
import { default as commoditiesb21KV3kdeFz3UHqUpE_6c7u8ZlHaAi4wNzrBRD9z1fcMeta } from "/app/pages/commodities.vue?macro=true";
import { default as _91slug_93OY1eKGH50IeGHXpXb3BdZRgtgqHXLtURcDbb48n4NVYMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as copy_45tradingaShrtlzAK6O5HZU3Dy7jxhNKfF_45c0XW3q336TPO7Cn4Meta } from "/app/pages/copy-trading.vue?macro=true";
import { default as old_45register2MJHhGLLAB0y4_45G7084Bs3yqG2cajMQWj5VN87lhmQAMeta } from "/app/pages/old-register.vue?macro=true";
import { default as account_45typesjnk6d1hOxZUgIqppnUVKdackNl0ncHPROpfUqq1_45MYsMeta } from "/app/pages/account-types.vue?macro=true";
import { default as trading_45hoursFiWNy6hFdHTJGyhJTipdG2f6t_45s8z8wd5rZpUZ6GVVkMeta } from "/app/pages/trading-hours.vue?macro=true";
import { default as trading_45tools_cpzacnXQkhKDchWTb8xCQlhzAYP6LABZe_HvCrNvw0Meta } from "/app/pages/trading-tools.vue?macro=true";
import { default as cfd_45asset_45listnmhVVfz7FF8ndUPjAITyXLQFLNXnRY5OhCnNjnnCEzEMeta } from "/app/pages/cfd-asset-list.vue?macro=true";
import { default as privacy_45policyzgG_45S68_451GHrVnCshLKLsmg43yjC4fB7Q3UU1pkWXTMMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as trading_45basicsfEpwOBcvk9WSu1uwoeAfQE5EUwTBgjNw_452aut2TNTfUMeta } from "/app/pages/trading-basics.vue?macro=true";
import { default as forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as _91slug_93NwYcrjUAE_45j9lTJ6spTMk4Kzep5hwi6BuXmKvxKYrX8Meta } from "/app/pages/job-post/[slug].vue?macro=true";
import { default as education_45centerVKcUDxZ3Ni4690lkXhcC6dTvFy7cCaz75iFcArxJyLIMeta } from "/app/pages/education-center.vue?macro=true";
import { default as _91slug_93ARHYKpWlVdhAgfFPhSftKoBoE4EwQikhPAlZWbuJFSAMeta } from "/app/pages/education/[slug].vue?macro=true";
import { default as _91slug_93H5XSbjyteMcgnlgluC3r22cCt8_45qL9YPHiebBTO5aGQMeta } from "/app/pages/news-tags/[slug].vue?macro=true";
import { default as cookie_45disclosureAof1yzmiXXxYPYuGlMJER7H0ZqhQ8M_45jVAqDC0PnDBMMeta } from "/app/pages/cookie-disclosure.vue?macro=true";
import { default as index6cWX3E5ypS5_45X80_d9SHXya86zFDD_457if8o2aujhmiEMeta } from "/app/pages/news-center/index.vue?macro=true";
import { default as _91slug_93L3aBJBKp2OS_45oAlmhV56nt4jDmdCDmB2ZU9uzGoWqQ8Meta } from "/app/pages/news-category/[slug].vue?macro=true";
import { default as _91slug_9370Bt7xqN_AcV5YTE6fb68sog4S9aP_1FC_vbZ1JOcFYMeta } from "/app/pages/education-tags/[slug].vue?macro=true";
import { default as _91_91id_93_933b4myJ18Nu90Rcl8SG4XRhyW6W7QfXvcDX5rDV2URfUMeta } from "/app/pages/news-center/news/[[id]].vue?macro=true";
import { default as _91slug_93U0Tt9gpEBr_45gMLzeqiuwlYrojZaM0kS04S45KaLh8p0Meta } from "/app/pages/education-authors/[slug].vue?macro=true";
import { default as _91slug_93s3LxGkgpiPgEe5kdZKmQHcxeRHqA2l7vxrrnp_45RqgroMeta } from "/app/pages/education-category/[slug].vue?macro=true";
export default [
  {
    name: "ib___en___default",
    path: "/ib",
    component: () => import("/app/pages/ib.vue")
  },
  {
    name: "ib___en",
    path: "/en/ib",
    component: () => import("/app/pages/ib.vue")
  },
  {
    name: "ib___es",
    path: "/es/ib",
    component: () => import("/app/pages/ib.vue")
  },
  {
    name: "ib___it",
    path: "/it/ib",
    component: () => import("/app/pages/ib.vue")
  },
  {
    name: "app___en___default",
    path: "/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___es",
    path: "/es/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___it",
    path: "/it/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "mt5___en___default",
    path: "/mt5",
    component: () => import("/app/pages/mt5.vue")
  },
  {
    name: "mt5___en",
    path: "/en/mt5",
    component: () => import("/app/pages/mt5.vue")
  },
  {
    name: "mt5___es",
    path: "/es/mt5",
    component: () => import("/app/pages/mt5.vue")
  },
  {
    name: "mt5___it",
    path: "/it/mt5",
    component: () => import("/app/pages/mt5.vue")
  },
  {
    name: "faqs___en___default",
    path: "/faqs",
    component: () => import("/app/pages/faqs.vue")
  },
  {
    name: "faqs___en",
    path: "/en/faqs",
    component: () => import("/app/pages/faqs.vue")
  },
  {
    name: "faqs___es",
    path: "/es/faqs",
    component: () => import("/app/pages/faqs.vue")
  },
  {
    name: "faqs___it",
    path: "/it/faqs",
    component: () => import("/app/pages/faqs.vue")
  },
  {
    name: "tags___en___default",
    path: "/tags",
    component: () => import("/app/pages/tags.vue")
  },
  {
    name: "tags___en",
    path: "/en/tags",
    component: () => import("/app/pages/tags.vue")
  },
  {
    name: "tags___es",
    path: "/es/tags",
    component: () => import("/app/pages/tags.vue")
  },
  {
    name: "tags___it",
    path: "/it/tags",
    component: () => import("/app/pages/tags.vue")
  },
  {
    name: "about___en___default",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___it",
    path: "/it/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "error___en___default",
    path: "/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/en/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "error___es",
    path: "/es/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "error___it",
    path: "/it/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "forex___en___default",
    path: "/forex",
    component: () => import("/app/pages/forex.vue")
  },
  {
    name: "forex___en",
    path: "/en/forex",
    component: () => import("/app/pages/forex.vue")
  },
  {
    name: "forex___es",
    path: "/es/forex",
    component: () => import("/app/pages/forex.vue")
  },
  {
    name: "forex___it",
    path: "/it/forex",
    component: () => import("/app/pages/forex.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "crypto___en___default",
    path: "/crypto",
    component: () => import("/app/pages/crypto.vue")
  },
  {
    name: "crypto___en",
    path: "/en/crypto",
    component: () => import("/app/pages/crypto.vue")
  },
  {
    name: "crypto___es",
    path: "/es/crypto",
    component: () => import("/app/pages/crypto.vue")
  },
  {
    name: "crypto___it",
    path: "/it/crypto",
    component: () => import("/app/pages/crypto.vue")
  },
  {
    name: "stocks___en___default",
    path: "/stocks",
    component: () => import("/app/pages/stocks.vue")
  },
  {
    name: "stocks___en",
    path: "/en/stocks",
    component: () => import("/app/pages/stocks.vue")
  },
  {
    name: "stocks___es",
    path: "/es/stocks",
    component: () => import("/app/pages/stocks.vue")
  },
  {
    name: "stocks___it",
    path: "/it/stocks",
    component: () => import("/app/pages/stocks.vue")
  },
  {
    name: "why-us___en___default",
    path: "/why-us",
    component: () => import("/app/pages/why-us.vue")
  },
  {
    name: "why-us___en",
    path: "/en/why-us",
    component: () => import("/app/pages/why-us.vue")
  },
  {
    name: "why-us___es",
    path: "/es/why-us",
    component: () => import("/app/pages/why-us.vue")
  },
  {
    name: "why-us___it",
    path: "/it/why-us",
    component: () => import("/app/pages/why-us.vue")
  },
  {
    name: "careers___en___default",
    path: "/careers",
    component: () => import("/app/pages/careers.vue")
  },
  {
    name: "careers___en",
    path: "/en/careers",
    component: () => import("/app/pages/careers.vue")
  },
  {
    name: "careers___es",
    path: "/es/careers",
    component: () => import("/app/pages/careers.vue")
  },
  {
    name: "careers___it",
    path: "/it/careers",
    component: () => import("/app/pages/careers.vue")
  },
  {
    name: "contact___en___default",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___it",
    path: "/it/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "indices___en___default",
    path: "/indices",
    component: () => import("/app/pages/indices.vue")
  },
  {
    name: "indices___en",
    path: "/en/indices",
    component: () => import("/app/pages/indices.vue")
  },
  {
    name: "indices___es",
    path: "/es/indices",
    component: () => import("/app/pages/indices.vue")
  },
  {
    name: "indices___it",
    path: "/it/indices",
    component: () => import("/app/pages/indices.vue")
  },
  {
    name: "glossary___en___default",
    path: "/glossary",
    component: () => import("/app/pages/glossary.vue")
  },
  {
    name: "glossary___en",
    path: "/en/glossary",
    component: () => import("/app/pages/glossary.vue")
  },
  {
    name: "glossary___es",
    path: "/es/glossary",
    component: () => import("/app/pages/glossary.vue")
  },
  {
    name: "glossary___it",
    path: "/it/glossary",
    component: () => import("/app/pages/glossary.vue")
  },
  {
    name: "partners___en___default",
    path: "/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___es",
    path: "/es/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___it",
    path: "/it/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "register___en___default",
    path: "/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "affiliate___en___default",
    path: "/affiliate",
    component: () => import("/app/pages/affiliate.vue")
  },
  {
    name: "affiliate___en",
    path: "/en/affiliate",
    component: () => import("/app/pages/affiliate.vue")
  },
  {
    name: "affiliate___es",
    path: "/es/affiliate",
    component: () => import("/app/pages/affiliate.vue")
  },
  {
    name: "affiliate___it",
    path: "/it/affiliate",
    component: () => import("/app/pages/affiliate.vue")
  },
  {
    name: "webtrader___en___default",
    path: "/webtrader",
    component: () => import("/app/pages/webtrader.vue")
  },
  {
    name: "webtrader___en",
    path: "/en/webtrader",
    component: () => import("/app/pages/webtrader.vue")
  },
  {
    name: "webtrader___es",
    path: "/es/webtrader",
    component: () => import("/app/pages/webtrader.vue")
  },
  {
    name: "webtrader___it",
    path: "/it/webtrader",
    component: () => import("/app/pages/webtrader.vue")
  },
  {
    name: "regulation___en___default",
    path: "/regulation",
    component: () => import("/app/pages/regulation.vue")
  },
  {
    name: "regulation___en",
    path: "/en/regulation",
    component: () => import("/app/pages/regulation.vue")
  },
  {
    name: "regulation___es",
    path: "/es/regulation",
    component: () => import("/app/pages/regulation.vue")
  },
  {
    name: "regulation___it",
    path: "/it/regulation",
    component: () => import("/app/pages/regulation.vue")
  },
  {
    name: "cfd-trading___en___default",
    path: "/cfd-trading",
    component: () => import("/app/pages/cfd-trading.vue")
  },
  {
    name: "cfd-trading___en",
    path: "/en/cfd-trading",
    component: () => import("/app/pages/cfd-trading.vue")
  },
  {
    name: "cfd-trading___es",
    path: "/es/cfd-trading",
    component: () => import("/app/pages/cfd-trading.vue")
  },
  {
    name: "cfd-trading___it",
    path: "/it/cfd-trading",
    component: () => import("/app/pages/cfd-trading.vue")
  },
  {
    name: "commodities___en___default",
    path: "/commodities",
    component: () => import("/app/pages/commodities.vue")
  },
  {
    name: "commodities___en",
    path: "/en/commodities",
    component: () => import("/app/pages/commodities.vue")
  },
  {
    name: "commodities___es",
    path: "/es/commodities",
    component: () => import("/app/pages/commodities.vue")
  },
  {
    name: "commodities___it",
    path: "/it/commodities",
    component: () => import("/app/pages/commodities.vue")
  },
  {
    name: "news-slug___en___default",
    path: "/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___es",
    path: "/es/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news-slug___it",
    path: "/it/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "copy-trading___en___default",
    path: "/copy-trading",
    component: () => import("/app/pages/copy-trading.vue")
  },
  {
    name: "copy-trading___en",
    path: "/en/copy-trading",
    component: () => import("/app/pages/copy-trading.vue")
  },
  {
    name: "copy-trading___es",
    path: "/es/copy-trading",
    component: () => import("/app/pages/copy-trading.vue")
  },
  {
    name: "copy-trading___it",
    path: "/it/copy-trading",
    component: () => import("/app/pages/copy-trading.vue")
  },
  {
    name: "old-register___en___default",
    path: "/old-register",
    component: () => import("/app/pages/old-register.vue")
  },
  {
    name: "old-register___en",
    path: "/en/old-register",
    component: () => import("/app/pages/old-register.vue")
  },
  {
    name: "old-register___es",
    path: "/es/old-register",
    component: () => import("/app/pages/old-register.vue")
  },
  {
    name: "old-register___it",
    path: "/it/old-register",
    component: () => import("/app/pages/old-register.vue")
  },
  {
    name: "account-types___en___default",
    path: "/account-types",
    component: () => import("/app/pages/account-types.vue")
  },
  {
    name: "account-types___en",
    path: "/en/account-types",
    component: () => import("/app/pages/account-types.vue")
  },
  {
    name: "account-types___es",
    path: "/es/account-types",
    component: () => import("/app/pages/account-types.vue")
  },
  {
    name: "account-types___it",
    path: "/it/account-types",
    component: () => import("/app/pages/account-types.vue")
  },
  {
    name: "trading-hours___en___default",
    path: "/trading-hours",
    component: () => import("/app/pages/trading-hours.vue")
  },
  {
    name: "trading-hours___en",
    path: "/en/trading-hours",
    component: () => import("/app/pages/trading-hours.vue")
  },
  {
    name: "trading-hours___es",
    path: "/es/trading-hours",
    component: () => import("/app/pages/trading-hours.vue")
  },
  {
    name: "trading-hours___it",
    path: "/it/trading-hours",
    component: () => import("/app/pages/trading-hours.vue")
  },
  {
    name: "trading-tools___en___default",
    path: "/trading-tools",
    component: () => import("/app/pages/trading-tools.vue")
  },
  {
    name: "trading-tools___en",
    path: "/en/trading-tools",
    component: () => import("/app/pages/trading-tools.vue")
  },
  {
    name: "trading-tools___es",
    path: "/es/trading-tools",
    component: () => import("/app/pages/trading-tools.vue")
  },
  {
    name: "trading-tools___it",
    path: "/it/trading-tools",
    component: () => import("/app/pages/trading-tools.vue")
  },
  {
    name: "cfd-asset-list___en___default",
    path: "/cfd-asset-list",
    component: () => import("/app/pages/cfd-asset-list.vue")
  },
  {
    name: "cfd-asset-list___en",
    path: "/en/cfd-asset-list",
    component: () => import("/app/pages/cfd-asset-list.vue")
  },
  {
    name: "cfd-asset-list___es",
    path: "/es/cfd-asset-list",
    component: () => import("/app/pages/cfd-asset-list.vue")
  },
  {
    name: "cfd-asset-list___it",
    path: "/it/cfd-asset-list",
    component: () => import("/app/pages/cfd-asset-list.vue")
  },
  {
    name: "privacy-policy___en___default",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "trading-basics___en___default",
    path: "/trading-basics",
    component: () => import("/app/pages/trading-basics.vue")
  },
  {
    name: "trading-basics___en",
    path: "/en/trading-basics",
    component: () => import("/app/pages/trading-basics.vue")
  },
  {
    name: "trading-basics___es",
    path: "/es/trading-basics",
    component: () => import("/app/pages/trading-basics.vue")
  },
  {
    name: "trading-basics___it",
    path: "/it/trading-basics",
    component: () => import("/app/pages/trading-basics.vue")
  },
  {
    name: "forgot-password___en___default",
    path: "/forgot-password",
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___it",
    path: "/it/forgot-password",
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "job-post-slug___en___default",
    path: "/job-post/:slug()",
    component: () => import("/app/pages/job-post/[slug].vue")
  },
  {
    name: "job-post-slug___en",
    path: "/en/job-post/:slug()",
    component: () => import("/app/pages/job-post/[slug].vue")
  },
  {
    name: "job-post-slug___es",
    path: "/es/job-post/:slug()",
    component: () => import("/app/pages/job-post/[slug].vue")
  },
  {
    name: "job-post-slug___it",
    path: "/it/job-post/:slug()",
    component: () => import("/app/pages/job-post/[slug].vue")
  },
  {
    name: "education-center___en___default",
    path: "/education-center",
    component: () => import("/app/pages/education-center.vue")
  },
  {
    name: "education-center___en",
    path: "/en/education-center",
    component: () => import("/app/pages/education-center.vue")
  },
  {
    name: "education-center___es",
    path: "/es/education-center",
    component: () => import("/app/pages/education-center.vue")
  },
  {
    name: "education-center___it",
    path: "/it/education-center",
    component: () => import("/app/pages/education-center.vue")
  },
  {
    name: "education-slug___en___default",
    path: "/education/:slug()",
    component: () => import("/app/pages/education/[slug].vue")
  },
  {
    name: "education-slug___en",
    path: "/en/education/:slug()",
    component: () => import("/app/pages/education/[slug].vue")
  },
  {
    name: "education-slug___es",
    path: "/es/education/:slug()",
    component: () => import("/app/pages/education/[slug].vue")
  },
  {
    name: "education-slug___it",
    path: "/it/education/:slug()",
    component: () => import("/app/pages/education/[slug].vue")
  },
  {
    name: "news-tags-slug___en___default",
    path: "/news-tags/:slug()",
    component: () => import("/app/pages/news-tags/[slug].vue")
  },
  {
    name: "news-tags-slug___en",
    path: "/en/news-tags/:slug()",
    component: () => import("/app/pages/news-tags/[slug].vue")
  },
  {
    name: "news-tags-slug___es",
    path: "/es/news-tags/:slug()",
    component: () => import("/app/pages/news-tags/[slug].vue")
  },
  {
    name: "news-tags-slug___it",
    path: "/it/news-tags/:slug()",
    component: () => import("/app/pages/news-tags/[slug].vue")
  },
  {
    name: "cookie-disclosure___en___default",
    path: "/cookie-disclosure",
    component: () => import("/app/pages/cookie-disclosure.vue")
  },
  {
    name: "cookie-disclosure___en",
    path: "/en/cookie-disclosure",
    component: () => import("/app/pages/cookie-disclosure.vue")
  },
  {
    name: "cookie-disclosure___es",
    path: "/es/cookie-disclosure",
    component: () => import("/app/pages/cookie-disclosure.vue")
  },
  {
    name: "cookie-disclosure___it",
    path: "/it/cookie-disclosure",
    component: () => import("/app/pages/cookie-disclosure.vue")
  },
  {
    name: "news-center___en___default",
    path: "/news-center",
    component: () => import("/app/pages/news-center/index.vue")
  },
  {
    name: "news-center___en",
    path: "/en/news-center",
    component: () => import("/app/pages/news-center/index.vue")
  },
  {
    name: "news-center___es",
    path: "/es/news-center",
    component: () => import("/app/pages/news-center/index.vue")
  },
  {
    name: "news-center___it",
    path: "/it/news-center",
    component: () => import("/app/pages/news-center/index.vue")
  },
  {
    name: "news-category-slug___en___default",
    path: "/news-category/:slug()",
    component: () => import("/app/pages/news-category/[slug].vue")
  },
  {
    name: "news-category-slug___en",
    path: "/en/news-category/:slug()",
    component: () => import("/app/pages/news-category/[slug].vue")
  },
  {
    name: "news-category-slug___es",
    path: "/es/news-category/:slug()",
    component: () => import("/app/pages/news-category/[slug].vue")
  },
  {
    name: "news-category-slug___it",
    path: "/it/news-category/:slug()",
    component: () => import("/app/pages/news-category/[slug].vue")
  },
  {
    name: "education-tags-slug___en___default",
    path: "/education-tags/:slug()",
    component: () => import("/app/pages/education-tags/[slug].vue")
  },
  {
    name: "education-tags-slug___en",
    path: "/en/education-tags/:slug()",
    component: () => import("/app/pages/education-tags/[slug].vue")
  },
  {
    name: "education-tags-slug___es",
    path: "/es/education-tags/:slug()",
    component: () => import("/app/pages/education-tags/[slug].vue")
  },
  {
    name: "education-tags-slug___it",
    path: "/it/education-tags/:slug()",
    component: () => import("/app/pages/education-tags/[slug].vue")
  },
  {
    name: "news-center-news-id___en___default",
    path: "/news-center/news/:id?",
    component: () => import("/app/pages/news-center/news/[[id]].vue")
  },
  {
    name: "news-center-news-id___en",
    path: "/en/news-center/news/:id?",
    component: () => import("/app/pages/news-center/news/[[id]].vue")
  },
  {
    name: "news-center-news-id___es",
    path: "/es/news-center/news/:id?",
    component: () => import("/app/pages/news-center/news/[[id]].vue")
  },
  {
    name: "news-center-news-id___it",
    path: "/it/news-center/news/:id?",
    component: () => import("/app/pages/news-center/news/[[id]].vue")
  },
  {
    name: "education-authors-slug___en___default",
    path: "/education-authors/:slug()",
    component: () => import("/app/pages/education-authors/[slug].vue")
  },
  {
    name: "education-authors-slug___en",
    path: "/en/education-authors/:slug()",
    component: () => import("/app/pages/education-authors/[slug].vue")
  },
  {
    name: "education-authors-slug___es",
    path: "/es/education-authors/:slug()",
    component: () => import("/app/pages/education-authors/[slug].vue")
  },
  {
    name: "education-authors-slug___it",
    path: "/it/education-authors/:slug()",
    component: () => import("/app/pages/education-authors/[slug].vue")
  },
  {
    name: "education-category-slug___en___default",
    path: "/education-category/:slug()",
    component: () => import("/app/pages/education-category/[slug].vue")
  },
  {
    name: "education-category-slug___en",
    path: "/en/education-category/:slug()",
    component: () => import("/app/pages/education-category/[slug].vue")
  },
  {
    name: "education-category-slug___es",
    path: "/es/education-category/:slug()",
    component: () => import("/app/pages/education-category/[slug].vue")
  },
  {
    name: "education-category-slug___it",
    path: "/it/education-category/:slug()",
    component: () => import("/app/pages/education-category/[slug].vue")
  }
]